import { HouseholdsToCalculatorResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { SelectedFilters } from '../../types/filters.type';
import { AdapterInterface } from '../../types/global';
import adaptFilterRequest from './adaptFilterRequest';
import BaseAdapter from './baseAdapter';

export default class PostHouseholdsToCalculator extends BaseAdapter<HouseholdsToCalculatorResponse> implements AdapterInterface {
  rawResponse: HouseholdsToCalculatorResponse;

  async adaptResponse(request: { data: SelectedFilters }): Promise<string> {
    const formattedRequest = adaptFilterRequest(request.data);
    await this.fetchApiResponse('/api/households-to-calculator', HTTPMethod.Post, formattedRequest);
    return this.rawResponse.calculator_cases_url;
  }
}
